import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";

import { ApiService } from './api.service';
import { JwtService } from './jwt.service';
import { User } from '../models';
import { Observable ,  BehaviorSubject ,  ReplaySubject } from 'rxjs';
import {map, distinctUntilChanged, tap} from 'rxjs/operators';
import {HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private currentUserSubject = new BehaviorSubject<User>({} as User);
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  constructor(
      private http: HttpClient,
      private apiService: ApiService,
      private jwtService: JwtService,
  ) {}

    public get userValue(): User {
        return this.currentUserSubject.value;
    }

  // Verify JWT in localstorage with server & load user's info.
  // This runs once on application startup.
  populate() {
    // If JWT detected, attempt to get & store user's info
    if (this.jwtService.getToken()) {
      /*this.apiService.get('customers/current-profile')
          .subscribe(
              data => this.setAuth(data.content),
              err => this.purgeAuth()
          );*/
        this.isAuthenticatedSubject.next(true);
        //console.log('authenticated');
    } else {
      // Remove any potential remnants of previous auth states
      this.purgeAuth();
    }
  }

    createCustomer(mobile): Observable<User> {
        this.purgeAuth();
        return this.apiService.post('mobile/customers', mobile)
            .pipe(map(
                data => {
                    this.setCustomer(data.content.id);
                    //console.warn('returned data:',data);
                    return data;
                }
            ));
    }


    defineCurentuser(): Observable<User> { 
        return this.apiService.get('merchants/current-user' )
            .pipe(map(
                data => { 
                     
                    return data;
                    
                }
                
               
            ));
    }

    
    setCustomer(customerId) {
        window.localStorage['custId'] = customerId;
    }

    /*setAuth(token, refreshToken) {
        // Save JWT sent from server in localstorage
        this.jwtService.saveToken(token,refreshToken);
        // Set current user data into observable
        //this.currentUserSubject.next(user);
        // Set isAuthenticated to true
        this.isAuthenticatedSubject.next(true);
    }*/

    setAuth(user: User) {
        // Save JWT sent from server in localstorage
       // console.log('user',user)
        this.jwtService.saveToken(user.access_token);
        this.jwtService.saveRefreshToken(user.refresh_token);
        // Set current user data into observable
        this.currentUserSubject.next(user);
        // Set isAuthenticated to true
        this.isAuthenticatedSubject.next(true);
    }


  purgeAuth() {
    // Remove JWT from localstorage
    this.jwtService.destroyToken();
    // Set current user to an empty object
    this.currentUserSubject.next({} as User);
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
    // expire clear timeout
    this.stopRefreshTokenTimer();
  }

  /*attemptAuth(credentials): Observable<User> {
    this.purgeAuth();
    return this.apiService.post('mobile-users/auth', credentials)
        .pipe(map(
            data => {
                this.startRefreshTokenTimer(data.content.expires_in);
                this.setAuth(data.content.access_token,data.content.refresh_token);
              //console.warn('returned data',data.content.access_token);
              return data;
            }
        ));
  }*/

    attemptAuth(credentials): Observable<User> {
        this.purgeAuth();
        return this.apiService.post('mobile-users/auth', credentials)
            .pipe(map(
                data => {
                    this.startRefreshTokenTimer(data.content.expires_in);
                    this.setAuth(data.content);
                    //console.warn('returned data',data.content.access_token);
                    return data;
                }
            ));
    }
 
    refreshToken() {

       const refreshToken = this.jwtService.getRefreshToken();
       var body = "grant_type=refresh_token" + "&refresh_token=" + refreshToken;
      //  console.log('refresh token',body);
       /*let headers = new HttpHeaders();
        headers.append('Authorization', 'Basic ' +
            'Qk5QTF9BUF9DTElFTlQ6JDJhJDEwJDVJWjlmNHg2eFMzVW5SaXguNTdZOC5kTmllbzRvUDR3MFpacjVTOTRaVXAuVGI3MFF3S3RT');*/

        let headersConfig = { 
            grant_type: "refresh_token",
            refresh_token: refreshToken
        };
         
    //    let headers = new HttpHeaders().set('Authorization', `Basic Qk5QTF9BUF9DTElFTlQ6JDJhJDEwJDVJWjlmNHg2eFMzVW5SaXguNTdZOC5kTmllbzRvUDR3MFpacjVTOTRaVXAuVGI3MFF3S3RT`);

    //     headers = headers.append('Authorization', `Basic Qk5QTF9BUF9DTElFTlQ6JDJhJDEwJDVJWjlmNHg2eFMzVW5SaXguNTdZOC5kTmllbzRvUDR3MFpacjVTOTRaVXAuVGI3MFF3S3RT`);
    //     console.log('start run now',body);

    //     return this.http.post<any>(`${environment.base_url}oauth/token`, headersConfig, {headers} )
    //         .pipe(map((data) => {
    //             /*this.currentUserSubject.next(user);*/
    //             console.log('start inside',body);
    //             this.startRefreshTokenTimer(data.content.expires_in);
    //             //this.setAuth(data.content.access_token,data.content.refresh_token);
    //             this.setAuth(data.content);
    //             return data;

    //         }));


    return this.apiService.post('mobile-users/auth' , headersConfig )
    .pipe(map(
        data => {
              this.startRefreshTokenTimer(data.content.expires_in);
             this.setAuth(data.content);
         //   console.warn('start new refresh token',refreshToken);
            return data;
        } 
    ));

    

    }

    // helper methods

    timer;

    private refreshTokenTimeout;

    private startRefreshTokenTimer(expires_in) {
        // parse json object from base64 encoded jwt token
       /* const jwtToken = JSON.parse(atob(this.userValue.jwtToken.split('.')[1]));

        // set a timeout to refresh the token a minute before it expires
        const expires = new Date(jwtToken.exp * 1000);
        const timeout = expires.getTime() - Date.now() - (60 * 1000);*/
        // console.log('expires_in',expires_in);
        const timeout = (expires_in * 60) - ( 60 * 1000);
        // console.log('Date.now',Date.now(),'expires_in',expires_in,'timeout',timeout)
        this.timer = setTimeout(() => this.refreshToken().subscribe(), timeout);
        
    }

    private stopRefreshTokenTimer() {
        clearTimeout(this.timer);
        window.clearTimeout(this.timer);
    }

  getCurrentUser(): User {
    return this.currentUserSubject.value;
  }

    // Update the user on the server (email, pass, etc)
    update(user): Observable<User> {
        return this.apiService
            .put('/user', { user })
            .pipe(map(data => {
                // Update the currentUser observable
                this.currentUserSubject.next(data.user);
                return data.user;
            }));
    }

    getCustomer(): String {
        return window.localStorage['custId'];
    }

    // Update customer (email, pass, etc)
    updateCustomer(formData): Observable<User> {
        return this.apiService
            .put('mobile/customers/'+this.getCustomer(), formData)
            .pipe(map(data => {
                // Update the currentUser observable
                //this.currentUserSubject.next(data.user);
                console.warn('updateCustomer data',data)
                //this.setAuth(data.content.mobileAuthResponse.access_token,data.content.mobileAuthResponse.refresh_token);
                this.setAuth(data.content.mobileAuthResponse);
                return data;
            }));
    }

    // verify OTP
    verifyOtp(otp): Observable<User> {
        //console.warn('otp url','mobile/customers/'+this.getCustomer()+'?otp='+otp);
        return this.apiService
            .get('mobile/customers/'+this.getCustomer()+'?otp='+otp )
            .pipe(map(data => {
                // Update the currentUser observable
                //this.currentUserSubject.next(data.user);
                return data;
            }));
    }

    // resend OTP
    resendOtp(): Observable<User> {
        //console.warn('resend otp url','mobile/customers/'+this.getCustomer()+'/resend-otp');
        return this.apiService
            .put('mobile/customers/'+this.getCustomer()+'/resend-otp' )
            .pipe(map(data => {
                // Update the currentUser observable
                //this.currentUserSubject.next(data.user);
                return data;
            }));
    }

    // resend OTP
    updateBilling(formData): Observable<User> {
        //console.warn('resend otp url','mobile/customers/'+this.getCustomer()+'/resend-otp');
        return this.apiService
            .put('customers/'+this.getCustomer()+'/address', formData)
            .pipe(map(data => {
                // Update the currentUser observable
                //this.currentUserSubject.next(data.user);
                return data;
            }));
    }

    // Create Pin
    createPin(formData): Observable<User> {
        //console.warn('otp url','mobile/customers/'+this.getCustomer()+'?otp='+otp);
        return this.apiService
            .post('mobile/customers/'+this.getCustomer()+'/pin-no', formData )
            .pipe(map(data => {
                // Update the currentUser observable
                //this.currentUserSubject.next(data.user);
                sessionStorage.removeItem('pinNo');
                return data;
            }));
    }

    getProvinces() {
        return this.apiService
            .get('provinces' )
            .pipe(map(data => {
                // Update the currentUser observable
                //this.currentUserSubject.next(data.user);
                return data;
            }));
    }

    getDistricts(province) {
        return this.apiService
            .get('provinces/'+ province + '/districts' )
            .pipe(map(data => {
                // Update the currentUser observable
                //this.currentUserSubject.next(data.user);
                return data;
            }));
    }

    getCities(province,district) {
        return this.apiService
            .get('provinces/'+ province + '/districts/' + district + '/cities')
            .pipe(map(data => {
                // Update the currentUser observable
                //this.currentUserSubject.next(data.user);
                return data;
            }));
    }
}